import React from "react";
import styled from "styled-components";

const upcomingWorkshops = [
  {
    id: 1,
    title: "סדנת יומן ויזואלי",
    emoji: "📒",
    date: "תאריך ___",
    location: "מיקום ___",
    bg: "var(--tint-rose)",
  },
  {
    id: 2,
    title: "סדנת קלפי נפש",
    emoji: "🃏",
    date: "תאריך ___",
    location: "מיקום ___",
    bg: "var(--tint-butter)",
  },
  {
    id: 3,
    title: "סדנת לוח חזון",
    emoji: "🌟",
    date: "תאריך ___",
    location: "מיקום ___",
    bg: "var(--tint-rose)",
  },
];

export default function WorkshopsPreview({ navigate }) {
  return (
    <Wrapper id="workshops" className="greenBg">
      <div className="container">
        <Header>
          <div>
            <p className="font15 semiBold" style={{ color: "var(--rose-600)" }}>בואי ליצור יחד</p>
            <h2 className="font40 extraBold darkColor" style={{ marginTop: "8px" }}>
              סדנאות קרובות 🌸
            </h2>
          </div>
          <AllWorkshopsBtn
            onClick={() => navigate("workshops")}
            className="pinkBg whiteColor radius8 pointer semiBold font15"
          >
            לכל הסדנאות ←
          </AllWorkshopsBtn>
        </Header>

        <CardsGrid>
          {upcomingWorkshops.map((w) => (
            <WorkshopCard key={w.id} className="radius8">
              {/* IMAGE PLACEHOLDER — swap for a photo of this workshop */}
              <CardImg style={{ background: w.bg }}>
                <span>📸 תמונת סדנה: {w.title}</span>
              </CardImg>
              <CardBody>
                <CardEmoji>{w.emoji}</CardEmoji>
                <h3 className="font20 extraBold darkColor" style={{ margin: "8px 0 12px" }}>
                  {w.title}
                </h3>
                <MetaRow>
                  <MetaItem className="font13">📅 {w.date}</MetaItem>
                  <MetaItem className="font13">📍 {w.location}</MetaItem>
                </MetaRow>
                <RegisterBtn
                  onClick={() => navigate("workshops")}
                  className="pinkBg whiteColor radius8 pointer semiBold font13"
                >
                  לפרטים ולהרשמה →
                </RegisterBtn>
              </CardBody>
            </WorkshopCard>
          ))}
        </CardsGrid>

        <BottomNote className="font14 darkColor">
          📩 לשאלות ופרטים נוספים:{" "}
          <ContactLink onClick={() => navigate("contact")} className="semiBold">
            לחצי כאן
          </ContactLink>
        </BottomNote>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 40px;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
`;
const AllWorkshopsBtn = styled.button`
  padding: 12px 22px;
  border: none;
  cursor: pointer;
  white-space: nowrap;
`;
const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  @media (max-width: 860px) { grid-template-columns: 1fr; }
`;
const WorkshopCard = styled.div`
  background: var(--glass-strong);
  backdrop-filter: blur(6px);
  box-shadow: var(--shadow-card);
  overflow: hidden;
  transition: transform 0.6s var(--ease-spring), box-shadow 0.6s var(--ease-out);
  &:hover { transform: translateY(-8px); box-shadow: var(--shadow-lift); }
`;
const CardImg = styled.div`
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ink);
`;
const CardBody = styled.div`
  padding: 20px 22px 24px;
`;
const CardEmoji = styled.div`
  font-size: 1.5rem;
`;
const MetaRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 18px;
`;
const MetaItem = styled.span`
  color: var(--ink-muted);
`;
const RegisterBtn = styled.button`
  padding: 10px 18px;
  border: none;
  cursor: pointer;
  width: 100%;
`;
const BottomNote = styled.p`
  text-align: center;
  margin-top: 40px;
`;
const ContactLink = styled.span`
  color: var(--rose-600);
  cursor: pointer;
  text-decoration: underline;
  &:hover { opacity: 0.75; }
`;
